import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ModalTypes } from "@lib/enums/ModalTypes";
import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";
import { Box } from "@ecco/ui/box";
import { BoxWithRibbon } from "../BoxWithRIbbon";

const JoinEccoClub = () => {
    const { showModal } = useGlobalModalContext();
    const handleJoinEccoClub = () => {
        showModal(ModalTypes.upgradeAccount);
    };

    const { getMultiple } = useMicrocopy();

    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.joinTheClubTitle,
            CommonCMS.loyalty.joinTheClubDescription,
        ]);
    })();

    return (
        <BoxWithRibbon>
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                flexWrap={"wrap"}
                padding={[2, 4]}
            >
                <Box display={"column"}>
                    <Text fontWeight={"semibold"} mb={2} fontSize={"md"}>
                        {microcopies[CommonCMS.joinTheClubTitle]}
                    </Text>
                    <Text>{microcopies[CommonCMS.loyalty.joinTheClubDescription]}</Text>
                </Box>
                <Box minWidth={"40"} marginTop={[4, 0]}>
                    <Button
                        width={"100%"}
                        onClick={handleJoinEccoClub}
                        variant={"solid"}
                        mr="px"
                        sx={{
                            _hover: {
                                textDecoration: "none",
                            },
                        }}
                    >
                        <span>{microcopies[CommonCMS.joinTheClubTitle]}</span>
                    </Button>
                </Box>
            </Box>
        </BoxWithRibbon>
    );
};

export default JoinEccoClub;
